import { AccountCheckIcon } from './AccountCheckIcon';

/**
 * author: Google
 * id F3C76352-A033-4969-BBC4-99E2BEE84FAE
 * name account-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-check.svg
 * tags
 * - Account / User 
 */
export const AccountTickIcon = AccountCheckIcon;
export default AccountTickIcon